var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 31,
    viewBox: "0 0 97 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.834 29.711l4.7-28.488h7.514l-4.7 28.488h-7.514zm34.77-27.789A18.964 18.964 0 0060.87.727c-7.43 0-12.66 3.865-12.702 9.403-.048 4.095 3.73 6.377 6.58 7.738 2.93 1.387 3.912 2.288 3.9 3.536-.019 1.907-2.336 2.773-4.497 2.773-3.008 0-4.606-.43-7.082-1.495l-.965-.455-1.051 6.378c1.753.793 5 1.483 8.373 1.52 7.894 0 13.03-3.819 13.086-9.73.025-3.247-1.983-5.71-6.31-7.742-2.627-1.32-4.25-2.196-4.219-3.533 0-1.184 1.363-2.45 4.306-2.45a13.457 13.457 0 015.622 1.094l.675.328 1.017-6.175v.005zm19.278-.67h-5.807c-1.801 0-3.15.504-3.937 2.362l-11.16 26.108h7.891s1.289-3.513 1.58-4.284l9.631.014c.224.995.915 4.267.915 4.267h6.974L86.882 1.251zM77.61 19.61c.623-1.639 2.994-7.964 2.994-7.964-.043.075.62-1.663 1-2.717l.507 2.457s1.439 6.81 1.736 8.224H77.61zM26.529 1.248l-7.365 19.41-.779-3.938c-1.37-4.55-5.637-9.48-10.41-11.95l6.728 24.916h7.954L34.49 1.248h-7.96z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.834 29.711l4.7-28.488h7.514l-4.7 28.488h-7.514zm34.77-27.789A18.964 18.964 0 0060.87.727c-7.43 0-12.66 3.865-12.702 9.403-.048 4.095 3.73 6.377 6.58 7.738 2.93 1.387 3.912 2.288 3.9 3.536-.019 1.907-2.336 2.773-4.497 2.773-3.008 0-4.606-.43-7.082-1.495l-.965-.455-1.051 6.378c1.753.793 5 1.483 8.373 1.52 7.894 0 13.03-3.819 13.086-9.73.025-3.247-1.983-5.71-6.31-7.742-2.627-1.32-4.25-2.196-4.219-3.533 0-1.184 1.363-2.45 4.306-2.45a13.457 13.457 0 015.622 1.094l.675.328 1.017-6.175v.005zm19.278-.67h-5.807c-1.801 0-3.15.504-3.937 2.362l-11.16 26.108h7.891s1.289-3.513 1.58-4.284l9.631.014c.224.995.915 4.267.915 4.267h6.974L86.882 1.251zM77.61 19.61c.623-1.639 2.994-7.964 2.994-7.964-.043.075.62-1.663 1-2.717l.507 2.457s1.439 6.81 1.736 8.224H77.61zM26.529 1.248l-7.365 19.41-.779-3.938c-1.37-4.55-5.637-9.48-10.41-11.95l6.728 24.916h7.954L34.49 1.248h-7.96z",
    fill: "#B0BCE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.346 1.23H.228l-.1.591c9.43 2.36 15.668 8.058 18.257 14.901L15.75 3.632c-.45-1.794-1.773-2.349-3.404-2.401z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.346 1.23H.228l-.1.591c9.43 2.36 15.668 8.058 18.257 14.901L15.75 3.632c-.45-1.794-1.773-2.349-3.404-2.401z",
    fill: "#B0BCE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.129 .727)",
    d: "M0 0h96.25v30H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b8c8621970dc72d7862ffa371334d4c2.svg";
export { ForwardRef as ReactComponent };